<!-- Generator: Adobe Illustrator 28.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg enable-background='new 0 0 250 205' height='205px' version='1.1' viewBox='0 0 250 205' width='250px'
     x='0px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' y='0px'>
<g id="graphics">
	<path d="M175.5,176.5h-1.8h-31.2l0,24h-7.4h-7.6l0-24H95.7h-2.2V58
		l1.4-1.5h3.9c2.3,0.8,4.5,1.9,5.9,3.6l25.1,31.3c2.9,3,7.7,3,10.6,0l24.8-31.2c1.4-1.8,3.6-2.9,5.9-2.7h2.9l1.5,1.5L175.5,176.5z" fill="#9A9A9A" stroke="#707070" stroke-miterlimit="10"
  />
  <path d="M187.5,35.1L150,75.4
		c-8.1,8.7-21.9,8.7-30.1,0L61.5,13.1l7-8L128,68.4c3.8,4.1,10.3,4.1,14.1,0l38.5-41.3L187.5,35.1z" fill="#DADADA" stroke="#707070" stroke-linejoin="round" stroke-miterlimit="10"/>
  <g id="Pfeil_Innenradius">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="135.5" x2="135.5" y1="39" y2="66.4"/>
      <g>
				<polygon fill="#285172" points="133,65.7 135.5,70 138,65.7 				"/>
			</g>
		</g>
	</g>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="104.5" x2="104.5" y1="60" y2="119"/>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="165.5" x2="165.5" y1="60" y2="119"/>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="108.6" x2="161.4" y1="112.5" y2="112.5"/>
      <g>
				<polygon fill="#285172" points="109.3,115 105,112.5 109.3,110 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="160.7,115 165,112.5 160.7,110 				"/>
			</g>
		</g>
	</g>
</g>
  <g id="texts">
	<rect fill="none" height="45" width="81" x="94" y="116.2"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="sinkWidth" transform="matrix(1 0 0 1 109.5996 125.0303)">{{dieWidth}}</text>
    <rect fill="none" height="29.6" width="80" x="96" y="26.4"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="bendInnerRadius" transform="matrix(1 0 0 1 111.3257 35.3076)">{{bendInnerRadius}}</text>
</g>
</svg>
